import {useState} from "react"

export const useCFApprovalCount = () => {
    const [reloadPendingApprovals, setReloadPendingApprovals] = useState(false);
    return [reloadPendingApprovals, setReloadPendingApprovals]
}
